import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const JobGroupDialog = ({
  open,
  onClose,
  onSave,
  onDelete,
  jobGroupName,
  setJobGroupName,
  error,
  isEditing,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          fontSize: { xs: "1.2rem", sm: "1.5rem" },
        }}
      >
        {isEditing ? t("admin.jobs.jobDialog.editTitle") : t("admin.jobs.jobDialog.addTitle")}
      </DialogTitle>

      <DialogContent sx={{ padding: { xs: "16px", sm: "20px 24px" } }}>
        <TextField
          label={t("admin.employees.filters.jobGroup") + " *"}
          fullWidth
          value={jobGroupName}
          onChange={(e) => setJobGroupName(e.target.value)}
          margin="dense"
          variant="outlined"
          error={!!error}
          helperText={error}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
            },
          }}
        />
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: { xs: "center", sm: "space-between" },
          padding: { xs: "12px", sm: "16px 24px" },
          flexDirection: { xs: "column", sm: "row" },
          gap: 1,
        }}
      >
        <Button
          onClick={onClose}
          color="secondary"
          sx={{ borderRadius: "8px", width: { xs: "100%", sm: "auto" } }}
        >
          {t("admin.jobs.jobDialog.cancel")}
        </Button>

        {isEditing && (
          <Button
            onClick={onDelete}
            color="error"
            sx={{
              color: "red",
              "&:hover": { backgroundColor: "red", color: "#fff" },
            }}
          >
            {t("admin.jobs.jobDialog.delete")}
          </Button>
        )}

        <Button
          onClick={onSave}
          color="primary"
          sx={{
            borderRadius: "8px",
            width: { xs: "100%", sm: "auto" },
            "&:hover": { backgroundColor: "blue", color: "#fff" },
          }}
        >
          {isEditing ? t("admin.jobs.jobDialog.update") : t("admin.jobs.jobDialog.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// PropTypes validation
JobGroupDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  jobGroupName: PropTypes.string.isRequired,
  setJobGroupName: PropTypes.func.isRequired,
  error: PropTypes.string,
  isEditing: PropTypes.bool.isRequired,
};

export default JobGroupDialog;
